module.exports = __webpack_public_path__ + "img/store.d9186d69.svg";